export default (state, action) => {
  switch (action.type) {
    case "OPEN_SIDEBAR":
      return {
        ...state,
        showSidebar: true,
        sidebarTriggerKey: action.data
      }
    case "CLOSE_SIDEBAR":
      return {
        ...state,
        showSidebar: false
      }
    case "TOGGLE_SIDEBAR":
      return {
        ...state,
        showSidebar: !state.showSidebar
      }
    case "TOGGLE_OFFCANVAS":
      return {
        ...state,
        showOffcanvas: !state.showOffcanvas
      }
    case "TOGGLE_ITEM_DETAIL_OFFCANVAS":
      return {
        ...state,
        showItemDetailOffcanvas: !state.showItemDetailOffcanvas
      }
    case "CLOSE_ITEM_DETAIL_OFFCANVAS":
      return {
        ...state,
        showItemDetailOffcanvas: false
      }
    case "TOGGLE_HELP_MODAL":
      return {
        ...state,
        showHelpModal: !state.showHelpModal
      }
    case "SET_IS_LOADING":
      return {
        ...state,
        isLoading: action.data
      }
    case "SET_BAR_CHART_DATE":
      return {
        ...state,
        barChartDate: action.data
      }
    default:
      return state;
  }
};
